import { createDeferred } from '@wix/wix-data-client-common-standalone'

export const createPublicApi = () => {
  let appApi
  const apiReady = createDeferred()

  return {
    init({ appApi: _appApi }) {
      appApi = _appApi
      apiReady.resolve()
    },

    api: {
      registerInterceptor: async (eventName, interceptor) => {
        await apiReady.promise
        appApi.registerInterceptor(eventName, interceptor)
      },
      unregisterInterceptor: async (eventName, interceptor) => {
        await apiReady.promise
        appApi.unregisterInterceptor(eventName, interceptor)
      },
      getDataSettings: () => appApi.getDataSettings(),
      updateDataSettings: settings => appApi.updateDataSettings(settings),
    },
  }
}
